module.exports = __webpack_public_path__ + "img/racecourse-vaal-turf-inner-2000.912ea811.svg";